define('modules/worker',["jquery", "app"], function($, App) {
    var maxWorkers = navigator.hardwareConcurrency;
    var workerCount = 0;
    var queue = [];
    function openWorker(options) {
        if(workerCount == maxWorkers) {
            queue.push(options);
        } else {
            var worker = new Worker(options.url);
            worker.postMessage(options.message);
            worker.onmessage = function(e) {
                worker.terminate();
                worker = null;
                workerCount--;

                options.onmessage(e);
                options = null;

                if(queue.length) {
                    openWorker(queue.shift());
                }
            };
            workerCount++;
        }
    }

    return {
        openWorker : openWorker,
        maxWorkers : maxWorkers
    };
});
